import { HubConnection, HubConnectionBuilder, HttpTransportType } from "@microsoft/signalr";
import { Subject } from 'rxjs';

import Auth from "Auth";
import { BookedAppointment } from 'interfaces/CareOnDemand/BookedAppointment';
import { OpenSlot } from 'interfaces/CareOnDemand/OpenSlot';

const rescheduleProviderCalendar$ = new Subject<{
    busySlots: BookedAppointment[];
    avaliableSlots: OpenSlot[];
    memberId: string;
    departmentTimeZoneName: string | null;
    selectedDate: Date;
}>();
export const RescheduleProviderCalendarService = {
    get: () => rescheduleProviderCalendar$.asObservable(),
    push: (
        args: { busySlots: BookedAppointment[];
                avaliableSlots: OpenSlot[];
                memberId: string;
                departmentTimeZoneName: string | null;
                selectedDate: Date }
        ) =>
        rescheduleProviderCalendar$.next(args),
};

const rescheduleSelectedAppointmentSlot$ = new Subject<{
    appointmentTypeId: string;
    memberId: string;
    appointmentIds: string[];
    startTime: Date;
    endTime: Date;
    selectedTimeZone: string;
    selectedOpenSlotEndTime: Date;
}>();
export const RescheduleSelectedAppointmentSlotService = {
    get: () => rescheduleSelectedAppointmentSlot$.asObservable(),
    push: (args: {
        memberId: string;
        appointmentIds: string[];
        startTime: Date;
        endTime: Date;
        selectedTimeZone: string;
        appointmentTypeId: string;
        selectedOpenSlotEndTime: Date;
    }) => rescheduleSelectedAppointmentSlot$.next(args),
};

let hubConnection: HubConnection | null = null;
const callUpdatesSubject = new Subject<{ callSid: string; status: string }>();

export const callTrackingService = {
  // Start connection for an appointment
    start: (appointmentId: string) => {
        if (hubConnection) return; // already started

        hubConnection = new HubConnectionBuilder()
        .withUrl(`/telehealthOutgoingCallHub`, {
            accessTokenFactory: () => Auth.getToken() ?? '',
            transport:
                HttpTransportType.WebSockets |
                HttpTransportType.ServerSentEvents |
                HttpTransportType.LongPolling,
        })
        .withAutomaticReconnect()
        .build();

        hubConnection
        .start()
        .then(() => {
            hubConnection?.invoke("SubscribeToAppointment", appointmentId);
        })
        .catch(err => console.error("Error starting hub:", err));

        // Bind event streams
        hubConnection.on("CallStatusUpdated", (data: { callSid: string; status: string }) => {
        callUpdatesSubject.next(data);
        });
    },

    // Observable to subscribe in UI
    getUpdates$: () => callUpdatesSubject.asObservable(),

    getHubConnection: () => hubConnection,

    // Invoke unsubscribe
    unsubscribe: (appointmentId: string) => {
        if (hubConnection) {
        hubConnection.invoke("UnsubscribeFromAppointment", appointmentId).catch(console.error);
        }
    },

    // Stop and cleanup
    stop: async (appointmentId: string) => {
        if (!hubConnection) return;
        try {
        await hubConnection.invoke("UnsubscribeFromAppointment", appointmentId);
        } catch (err) {
        console.warn("Unsubscribe failed:", err);
        }
        hubConnection.off("CallStatusUpdated");
        await hubConnection.stop();
        hubConnection = null;
    },
};
